import * as React from 'react';

import type * as api from '@gitbook/api-client';
import {
    Step,
    StepControls,
    StepControlsBackButton,
    StepControlsSubmitButton,
} from '@gitbook/spine-react';
import { assertIsDefined } from '@gitbook/util-ts';

import type { ContentKitElementProps } from '../types';
import { ContentKitStepperContext } from './context';

/**
 * Renderer for a step element with optional previous and next actions.
 */
export function ContentKitStepperStep(
    props: ContentKitElementProps<api.ContentKitStepperStep>
): React.ReactElement {
    const { element, renderElements } = props;

    const context = React.useContext(ContentKitStepperContext);
    assertIsDefined(context, 'Stepper context not found');
    const { loading, previous: onGoBack, next: onGoNext } = context;

    return (
        <Step>
            <div className="flex flex-col">{renderElements('inline', element.children)}</div>
            <StepControls>
                <StepControlsSubmitButton
                    onGoNext={element.next ? onGoNext : undefined}
                    loading={loading}
                />
                <StepControlsBackButton onGoBack={onGoBack} loading={loading} />
            </StepControls>
        </Step>
    );
}
